import React, { useCallback, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dhRefresh } from '@deephaven/icons';
import { Button } from '@deephaven/components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PandasReloadButton(_ref) {
  var onClick = _ref.onClick;
  var buttonRef = useRef(null);
  var handleClick = useCallback(e => {
    var _buttonRef$current;
    (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.blur();
    onClick(e);
  }, [onClick]);
  return /*#__PURE__*/_jsxs(Button, {
    ref: buttonRef,
    kind: "primary",
    className: "btn-pandas",
    onClick: handleClick,
    tooltip: "Click to refresh pandas dataframe, updates do not occur automatically.",
    children: ["pandas dataframe", /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: dhRefresh,
        transform: "shrink-1",
        className: "mr-1"
      }), "Reload"]
    })]
  });
}
export default PandasReloadButton;
//# sourceMappingURL=PandasReloadButton.js.map